import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import IconButton from 'material-ui/IconButton';
// import FileUpload from '@material-ui/icons/FileUpload';
import FileDownload from '@material-ui/icons/FileDownload';
// import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import { tagDisplayName } from '../../utils/globals';

const { Column } = Table;


const CustomerDocuments = (props) => (
  <Table dataSource={props.docs} rowKey="id">
    <Column
      title="Name"
      dataIndex="filename"
      key="filename"
    />
    <Column
      title="Location"
      dataIndex="display_path"
      key="display_path"
    />
    <Column
      title="Tags"
      key="tags"
      render={(text, record) => (
        <div>
          { record.tags.map((tag) => (<p key={tag.tag}>{tagDisplayName(tag.tag)}</p>)) }
        </div>
      )}
    />
    <Column
      title="Status"
      render={(text, record) => {
        if (record.uploaded) {
          if (record.verified) {
            return (<span>Document Verified</span>);
          }
          return (<span>Verification pending</span>);
        }
        return (<span>Not Uploaded</span>);
      }}
    />
    <Column
      title="Actions"
      render={(text, record) => (
        <div>
          <IconButton aria-label="Download document" disabled={!record.uploaded} href={record.download_url}>
            <FileDownload />
          </IconButton>
          {/* <IconButton aria-label="Upload document" disabled={record.uploaded}> */}
          {/* <FileUpload /> */}
          {/* </IconButton> */}
          {/* <IconButton aria-label="Verify document" disabled={record.verified || !record.uploaded}> */}
          {/* <AssignmentTurnedIn /> */}
          {/* </IconButton> */}
        </div>
      )}
    />
  </Table>
);

CustomerDocuments.propTypes = {
  docs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
};

export default CustomerDocuments;



// WEBPACK FOOTER //
// ./src/pages/customer/CustomerDocuments.jsx